"use client";

import React, { useState, useEffect } from 'react';

function validarCPF(cpf: string) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;
  let soma = 0, resto;
  for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if ((resto === 10) || (resto === 11)) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if ((resto === 10) || (resto === 11)) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
}

function validarEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function formatarCPF(valor: string) {
  return valor
    .replace(/\D/g, '') // Remove tudo o que não é dígito
    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o primeiro ponto
    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o segundo ponto
    .replace(/(\d{3})(\d{1,2})/, '$1-$2') // Adiciona o traço
    .replace(/(-\d{2})\d+?$/, '$1'); // Impede que passe do limite (14 caracteres)
}

function formatarCelular(valor: string) {
  const v = valor.replace(/\D/g, ''); // Remove tudo que não for número
  if (v.length <= 2) return v;
  if (v.length <= 7) return `(${v.slice(0, 2)}) ${v.slice(2)}`;
  return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7, 11)}`;
}

export default function CadastroPage() {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');
  const [nascimento, setNascimento] = useState('');
  const [ddi, setDdi] = useState('55');
  const [celular, setCelular] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [socioTorcedorFlu, setSocioTorcedorFlu] = useState(false);
  const [autorizoCompartilhamento, setAutorizoCompartilhamento] = useState(false);
  const [plano, setPlano] = useState('Não Sócio');
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');
  const [sucessoCadastro, setSucessoCadastro] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const planoParam = params.get('plano');
    if (planoParam) {
      setPlano(planoParam);
    }
  }, []);

  const handleCadastro = async (e: React.FormEvent) => {
    e.preventDefault();
    setMensagem('');
    setErro('');

    if (!validarEmail(email)) {
      setErro('Por favor, insira um e-mail válido.');
      return;
    }

    if (!validarCPF(cpf)) {
      setErro('Por favor, insira um CPF válido.');
      return;
    }

    if (senha !== confirmarSenha) {
      setErro('As senhas não coincidem.');
      return;
    }

    try {
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get('redirect') || '';

      const celularCompleto = ddi.replace(/\D/g, '') + celular.replace(/\D/g, '');
      const res = await fetch('https://api.arfainfo.com.br/api/cadastro', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nome,
          email,
          cpf: cpf.replace(/\D/g, ''),
          senha,
          nascimento,
          celular: celularCompleto,
          socio_torcedor_flu: socioTorcedorFlu,
          autorizo_compartilhamento_dados: autorizoCompartilhamento,
          plano,
          redirect
        })
      });

      const data = await res.json();

      if (res.ok && data.sucesso) {
        setSucessoCadastro(true);
      } else {
        setErro(data.mensagem || 'Erro ao realizar o cadastro.');
      }
    } catch (err) {
      setErro('Erro de conexão com o servidor.');
    }
  };

  return (
    <div className="cgt-root font-sans text-gray-900 flex flex-col justify-center min-h-screen py-12 sm:px-6 lg:px-8">
      <style>{`
        .cgt-logo { display: flex; align-items: center; gap: 2px; text-decoration: none; }
        .cgt-logo-text { display: flex; flex-direction: column; line-height: 1; margin-top: 2px; }
        .cgt-logo-text-1 { font-family: 'Montserrat', sans-serif; font-size: 10px; font-weight: 600; text-transform: uppercase; color: #333; }
        .cgt-logo-text-2 { font-family: 'Bebas Neue', sans-serif; font-size: 24px; color: #006437; letter-spacing: 0.5px; }
        .cgt-logo-text-3 { font-family: 'Montserrat', sans-serif; font-size: 10px; font-weight: 800; text-transform: uppercase; color: #8A1538; margin-top: -2px; }
      `}</style>
      <link href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Montserrat:ital,wght@0,400;0,600;0,700;0,800;0,900;1,400;1,800&display=swap" rel="stylesheet" />

      <div className="relative z-10 w-full">
        <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
          <a href="/" className="cgt-logo inline-flex mb-6">
            <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Casa do Guerreiro Tricolor" className="w-16 h-16 object-contain" />
            <div className="cgt-logo-text">
              <span className="cgt-logo-text-1">Casa do</span>
              <span className="cgt-logo-text-2 cgt-title-font">GUERREIRO</span>
              <span className="cgt-logo-text-3">Tricolor</span>
            </div>
          </a>
          <h2 className="mt-2 text-center text-2xl font-black text-gray-800 uppercase italic tracking-tighter">
            Crie sua conta
          </h2>
          <p className="mt-2 text-center text-sm font-medium text-gray-500">
            Preencha seus dados para se tornar um Guerreiro
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-[#fdfdfd] py-8 px-6 shadow-[0_10px_25px_rgba(0,0,0,0.04)] sm:rounded-xl sm:px-10 border border-[#ddd]">
          {sucessoCadastro ? (
            <div className="text-center space-y-5">
              <div className="w-16 h-16 bg-[#00c96e]/15 text-[#006437] rounded-full flex items-center justify-center mx-auto shadow-inner">
                <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              </div>

              <div>
                <span className="text-[10px] bg-green-100 text-[#006437] font-black px-2.5 py-1 rounded-full uppercase tracking-wider">
                  Etapa Obrigatória
                </span>
                <h3 className="text-2xl font-black text-[#6b1122] uppercase tracking-tight mt-2">
                  Confirme no WhatsApp!
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm mt-1">
                  Enviamos o link de confirmação para o seu WhatsApp no número <strong>{celular}</strong>.
                </p>
              </div>

              <div className="bg-[#f0f9ff] border border-[#bae6fd] rounded-xl p-4 text-xs text-[#0369a1] text-left space-y-2">
                <div className="font-bold flex items-center gap-1.5 text-xs text-[#0284c7] uppercase tracking-wider">
                  <span>📱</span> Próximo Passo:
                </div>
                <p className="leading-relaxed">
                  1. Abra o seu WhatsApp no celular ou computador.
                </p>
                <p className="leading-relaxed">
                  2. Clique no link que enviamos da <strong>Casa do Guerreiro Tricolor</strong>.
                </p>
                <p className="leading-relaxed">
                  3. {plano !== 'Não Sócio' 
                    ? `Após confirmar seu número, você entrará direto na tela de pagamento para ativar o plano ${plano}!`
                    : 'Após confirmar seu número, sua conta será validada para você acessar o portal!'}
                </p>
              </div>

              <a
                href="https://web.whatsapp.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-lg shadow-sm text-sm font-bold text-white bg-[#25D366] hover:bg-[#1ebc59] transition uppercase tracking-wide"
              >
                <span>Abrir WhatsApp Web</span>
                <span>›</span>
              </a>

              <p className="text-[11px] text-gray-400">
                Não recebeu? Verifique se digitou o DDD e número corretamente.
              </p>
            </div>
          ) : (
          <form className="space-y-6" onSubmit={handleCadastro} suppressHydrationWarning>
            {erro && <div className="bg-red-50 text-red-700 p-3 rounded-lg text-sm font-medium border border-red-100">{erro}</div>}
            {mensagem && <div className="bg-green-50 text-green-700 p-3 rounded-lg text-sm font-medium border border-green-100">{mensagem}</div>}

            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Nome completo</label>
              <input type="text" required value={nome} onChange={(e) => setNome(e.target.value)} className="mt-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm" suppressHydrationWarning />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">E-mail</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm" suppressHydrationWarning />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">CPF</label>
              <input type="text" required value={cpf} onChange={(e) => setCpf(formatarCPF(e.target.value))} placeholder="000.000.000-00" maxLength={14} className="mt-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm tabular-nums" suppressHydrationWarning />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Nascimento</label>
              <input type="date" required value={nascimento} onChange={(e) => setNascimento(e.target.value)} className="mt-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm box-border tabular-nums" suppressHydrationWarning />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Celular (WhatsApp)</label>
              <div className="flex gap-2">
                <div className="flex items-center bg-gray-100 border border-gray-300 rounded-lg shadow-sm px-3">
                  <span className="text-gray-500 font-bold text-sm mr-1">+</span>
                  <input type="text" value={ddi} onChange={(e) => setDdi(e.target.value.replace(/\D/g, '').substring(0, 3))} className="bg-transparent w-8 focus:outline-none text-sm font-bold text-gray-700 tabular-nums" suppressHydrationWarning />
                </div>
                <input type="text" required value={celular} onChange={(e) => setCelular(formatarCelular(e.target.value))} placeholder="(00) 00000-0000" maxLength={15} className="flex-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm tabular-nums" suppressHydrationWarning />
              </div>
            </div>

            <div suppressHydrationWarning>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Senha</label>
              <input type="password" required value={senha} onChange={(e) => setSenha(e.target.value)} className="mt-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm tracking-widest tabular-nums" suppressHydrationWarning />
            </div>

            <div suppressHydrationWarning>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Repetir Senha</label>
              <input type="password" required value={confirmarSenha} onChange={(e) => setConfirmarSenha(e.target.value)} className="mt-1 appearance-none block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm tracking-widest tabular-nums" suppressHydrationWarning />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Plano Desejado</label>
              <select
                value={plano}
                onChange={(e) => setPlano(e.target.value)}
                className="mt-1 block w-full bg-white px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-[#006437] focus:border-[#006437] sm:text-sm"
              >
                <option value="Não Sócio">Apenas Criar Conta (Não Sócio)</option>
                <option value="Guerreiro da Casa">Guerreiro da Casa</option>
                <option value="Sangue Grená">Sangue Grená</option>
                <option value="Lenda Tricolor">Lenda Tricolor</option>
              </select>
            </div>

            <div className="flex items-center space-x-3 pt-2">
              <input 
                type="checkbox" 
                id="socioTorcedorFlu"
                checked={socioTorcedorFlu} 
                onChange={(e) => setSocioTorcedorFlu(e.target.checked)} 
                className="h-4 w-4 text-[#006437] focus:ring-[#006437] border-gray-300 rounded" 
              />
              <label htmlFor="socioTorcedorFlu" className="block text-sm font-bold text-gray-700">
                Sou Sócio Torcedor do Fluminense
              </label>
            </div>

            <div className="flex items-start space-x-3 pt-1">
              <input 
                type="checkbox" 
                id="autorizoCompartilhamento"
                checked={autorizoCompartilhamento} 
                onChange={(e) => setAutorizoCompartilhamento(e.target.checked)} 
                className="h-4 w-4 mt-0.5 text-[#006437] focus:ring-[#006437] border-gray-300 rounded cursor-pointer" 
              />
              <label htmlFor="autorizoCompartilhamento" className="block text-xs font-semibold text-gray-600 leading-snug cursor-pointer">
                Autorizo o compartilhamento dos meus dados cadastrais com o Fluminense Football Club e a Casa do Guerreiro Tricolor para fins de validação e comunicação exclusiva.
              </label>
            </div>

            <div>
              <button type="submit" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-bold text-white bg-[#006437] hover:bg-[#004d2a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#006437] transition-colors uppercase tracking-wide">
                Cadastrar
              </button>
            </div>
          </form>
          )}
        </div>
        <div className="mt-8 text-center flex flex-col items-center space-y-4">
          <a href="/login" className="text-xs font-bold text-[#8A1538] hover:text-[#5a0c23] transition uppercase tracking-wider">
            Já tem conta? Faça login
          </a>
          <a href="/" className="text-xs font-bold text-gray-500 hover:text-gray-800 transition uppercase tracking-wider">
            ← Voltar para o Início
          </a>
        </div>
      </div>
    </div>
    </div>
  );
}
